export const SET_LANGUAGE = 'App/setLanguage'
